import {getHomepageData} from '../../../features/Homepage/actions/data';

export function getRecentUpdates() {
    window['GetRecentUpdates'] && window['GetRecentUpdates']();
}

export async function refreshHomePage() {
    await getHomepageData(false);
    console.log('==================== Refreshed New HomePage Data ====================');
}

export function reloadMainMenu() {
    window['reloadMainMenu'] && window['reloadMainMenu']();
}
